document.addEventListener('DOMContentLoaded', () => {
  const calculateBtn = document.getElementById('calculateBtn');
  const resultsDiv = document.getElementById('results');

  const baseCosts = {
    physio: 50000, chiro: 50000, medspa: 90000, psych: 50000,
    dental: 110000, general: 50000, iv: 50000, rehab: 50000
  };

  const locationMultipliers = { leased:1.0, sublease:0.9, home:0.8 };
  const marketMultipliers = { major:1.35, mid:1.15, small:1.0, rural:0.9 };
  const buildOutCosts = { none:0, light:15000, moderate:35000, heavy:60000 };

  const equipmentCosts = {
    physio: { minimal:10000, standard:20000, premium:35000 },
    chiro: { minimal:8000, standard:15000, premium:25000 },
    medspa: { minimal:25000, standard:45000, premium:70000 },
    psych: { minimal:3000, standard:6000, premium:10000 },
    dental: { minimal:60000, standard:120000, premium:200000 },
    general: { minimal:8000, standard:15000, premium:25000 },
    iv: { minimal:5000, standard:10000, premium:20000 },
    rehab: { minimal:8000, standard:15000, premium:30000 }
  };

  const practitionerCost = 80000;
  const adminCost = 45000;
  const cadToUsd = 0.75;

  calculateBtn.addEventListener('click', () => {
    const country = document.getElementById('country').value;
    const clinicType = document.getElementById('clinicType').value;
    const locationType = document.getElementById('locationType').value;
    const marketSize = document.getElementById('marketSize').value;
    const treatmentRooms = parseInt(document.getElementById('treatmentRooms').value,10);
    const buildOut = document.getElementById('buildOut').value;
    const practitioners = parseInt(document.getElementById('practitioners').value,10);
    const adminStaff = parseInt(document.getElementById('adminStaff').value,10);
    const equipmentTier = document.getElementById('equipmentTier').value;
    const workingCapitalPercent = parseFloat(document.getElementById('workingCapitalPercent').value)/100;

    // Base cost
    let total = baseCosts[clinicType];

    // Apply multipliers
    total *= locationMultipliers[locationType] || 1.0;
    total *= marketMultipliers[marketSize] || 1.0;

    // Space & Size
    total += treatmentRooms * 10000; 
    total += buildOutCosts[buildOut] || 0;

    // Staffing
    total += practitioners * practitionerCost;
    total += adminStaff * adminCost;

    // Equipment & Supplies
    total += equipmentCosts[clinicType][equipmentTier] || 0;

    // Working Capital
    total += total * workingCapitalPercent;

    // Currency conversion
    if(country === 'USD') total *= cadToUsd;
    const symbol = country;

    resultsDiv.innerHTML = `<strong>Estimated Startup Cost:</strong> ${symbol} $${Math.round(total).toLocaleString()}`;
  });
});
